import { defineMessages } from 'react-intl';

export const messages: {
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	descriptionWelcomeVariant: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	greeting: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	heading: {
		defaultMessage: string;
		description: string;
		id: string;
	}; // Variant 2 ("welcome") - TWCG-1856: updated welcome screen copy
	headingWelcomeVariant: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	setupMeetingRecordings: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	greeting: {
		id: 'twc.xflow.modal.welcome.greetingName',
		defaultMessage: 'Hi {name}!',
		description: 'Welcome screen greeting with user name',
	},
	heading: {
		id: 'twc.xflow.modal.welcome.heading',
		defaultMessage: 'Welcome to Teamwork Collection',
		description: 'Heading for the welcome screen',
	},
	description: {
		id: 'twc.xflow.modal.welcome.description',
		defaultMessage:
			"You've unlocked a smarter way for your team to connect, collaborate, and get more done.",
		description: 'Description text for the welcome screen',
	},
	setupMeetingRecordings: {
		id: 'twc-xflow-modal.twc-xflow-modal.screens.welcome-screen.setupMeetingRecordings',
		defaultMessage: 'Set up meeting recordings',
		description: 'CTA that opens Loom meeting recording settings after TWC provisioning',
	},
	// Variant 2 ("welcome") - TWCG-1856: updated welcome screen copy
	headingWelcomeVariant: {
		id: 'twc.xflow.modal.welcome.heading.welcomeVariant',
		defaultMessage: 'Welcome to your Teamwork Collection 🎉',
		description: 'Heading for the welcome screen - TWCG-1856 welcome variant',
	},
	descriptionWelcomeVariant: {
		id: 'twc.xflow.modal.welcome.description.welcomeVariant',
		defaultMessage:
			'Your team just got a serious upgrade! From projects to docs to video updates to AI — everything your team needs is here. Let us show you around.',
		description: 'Description text for the welcome screen - TWCG-1856 welcome variant',
	},
});
